export default function prepareLabel(label) {
  return typeof(label) === "string"
    ? label.replaceAll("_", " ")
    : "";
}
